// Scroll Down arrow
$('a[href]:not([target="_blank"])').on('click', function(e){
    e.preventDefault();
    if (!$(this).hasClass('thumbnails__item')) {
      var href = $(this).attr('href');
      if(href.indexOf('#') > -1){
        $('html, body').animate({ 
          scrollTop:$(href).offset().top
        },'slow');   
      }else{
       window.location.href = href;
      }
    }
});

var $anchors = document.querySelectorAll('.thumbnails__item');
if ($anchors) {
  for (var i = 0; i < $anchors.length; i++) {
    console.log($anchors[i].href);
    $anchors[i].addEventListener('click', function (e) {
      window.SmoothScroller.scrollTo('#' + this.href.split('#')[1], {
        duration: 1.2,
        easing: function expoInOut(x) {
          return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2;
        }
      });
      e.preventDefault();
      return false;
    });
  }
}

$('.project_categories li').on('click',function(e) {
  $(this).closest('ul').find('li').removeClass('active');
  $(this).addClass('active')
})

//Active menu on scoll section
$(window).scroll(function() {
  var scrollDistance = $(window).scrollTop();
  // Assign active class to nav links while scolling
  $('.service-section').each(function(i) {
    var id = $(this).attr('id');
    var posTop = $(this)[0].getBoundingClientRect().top + document.documentElement.scrollTop;
      if (posTop - 150 <= scrollDistance) {
          $('.navigation li a.active').removeClass('active');
          $('.navigation li').eq(i).find('a').addClass('active');
      }
  });
}).scroll();

// Animate Bubble
var $flareBanner = jQuery('#flare-banner');
if($flareBanner.length)
$flareBanner.prepend('<div class="flare-app app" data-component="flare" data-props="{&quot;type&quot;:&quot;homepage-banner&quot;}"></div>');
  jQuery("img").hover(
    function(){
      jQuery('#cursor').css('transform', 'scale(2)');
     }, function(){
      jQuery('#cursor').css('transform', '');
     }
);
if (window.innerWidth > 768) {
    var cursor = document.getElementById("cursor");
    document.body.addEventListener("mousemove", function(e) {
      //console.log(e.clientX,e.clientY)
        cursor.style.left = e.clientX + "px";
        cursor.style.top = e.clientY + "px";
    });
}


// Portfolio
$(function($) {
    $.autofilter();
});

// Parallax image banner
$('.img-parallax').each(function(){
  var img = $(this);
  var imgParent = $(this).parent();
  function parallaxImg () {
    var speed = img.data('speed');
    var imgY = imgParent.offset().top;
    var winY = $(this).scrollTop();
    var winH = $(this).height();
    var parentH = imgParent.innerHeight();


    // The next pixel to show on screen      
    var winBottom = winY + winH;

    // If block is shown on screen
    if (winBottom > imgY && winY < imgY + parentH) {
      // Number of pixels shown after block appear
      var imgBottom = ((winBottom - imgY) * speed);
      // Max number of pixels until block disappear
      var imgTop = winH + parentH;
      // Porcentage between start showing until disappearing
      var imgPercent = ((imgBottom / imgTop) * 100) + (50 - (speed * 50));
    }
    img.css({
      top: imgPercent + '%',
      transform: 'translate(-50%, -' + imgPercent + '%)'
    });
  }
  $(document).on({
    scroll: function () {
      parallaxImg();
    }, ready: function () {
      parallaxImg();
    }
  });
});
// // Menu Demo
// {
//   setTimeout(() => document.body.classList.add('render'), 60);
//   const navdemos = Array.from(document.querySelectorAll('nav.demos > .demo'));
//   const total = navdemos.length;
//   const current = navdemos.findIndex(el => el.classList.contains('demo--current'));
//   const navigate = (linkEl) => {
//     console.log(linkEl)
//      if(linkEl != undefined){
//       document.body.classList.remove('render');
//       document.body.addEventListener('transitionend', () => window.location = linkEl.href); 
//      }
//   };
//   navdemos.forEach(link => link.addEventListener('click', (ev) => {
//       ev.preventDefault();
//       navigate(ev.target);
//   }));
//   document.addEventListener('keydown', (ev) => {
//       const keyCode = ev.keyCode || ev.which;
//       let linkEl;
//       if ( keyCode === 37 ) {
//           linkEl = current > 0 ? navdemos[current-1] : navdemos[total-1];
//       }
//       else if ( keyCode === 39 ) {
//           linkEl = current < total-1 ? navdemos[current+1] : navdemos[0];
//       }
//       else {
//           return false;
//       }
//       navigate(linkEl);
//   });
// }
// // Menu Trigger JS
// $('.header__icon--menu').on('click', function(){
//   if ($(this).hasClass('is-opened-navi')) {
//     window.destroySmoothScroll();
//   } else {
//     window.initSmoothScroll();
//   }
//     $('.header__icon.header__icon--summary').trigger('click');
// });

// Filter dropdown
$(".default_option").click(function(){
  $(this).parent().toggleClass("active");
})

$(".select_ul li").click(function(){
  var currentele = $(this).html();
  $(".default_option li").html(currentele);
  $(this).parents(".select_wrap").removeClass("active");
})

if ($('.shopify-section.shopify-section--our-work').length > 0) {
  $('.shopify-section.shopify-section--our-work').not(':first').hide();
  $('.shopify-section.shopify-section--our-work').not(':first').find('.project_item').each(function(i, sec) {
    $(this).appendTo($('.shopify-section.shopify-section--our-work').first().find('.project_items'));
  })
  // Get the first project_categories ul
  var $firstUl = $('.project_categories').first();

  // Loop through each li in the subsequent ul elements
  $('.project_categories').not(':first').find('li').each(function() {
      var dataFilter = $(this).find('span').attr('data-filter');

      // Check if the li with the same data-filter exists in the first ul
      if ($firstUl.find('span[data-filter="' + dataFilter + '"]').length === 0) {
          // If not, append the li to the first ul
          $(this).appendTo($firstUl);
      }
  });
}